<template>
  <div>
    <el-row style="text-align: center;">
      <div style="font-size: 30px;margin-top: 20px">审查机构修改密码</div>
    </el-row>
    <el-row>
      <hr
        size="1"
        style="COLOR:#ff9999;border-style:double;color:#CCC;margin-top: 30px"
      />
    </el-row>
    <el-row style="text-align: left">
      <el-button type="text" icon="el-icon-arrow-left" @click="back"
        >返回登录页面</el-button
      >
    </el-row>
    <el-row type="flex" justify="center" style=" margin-top: 20px">
      <el-form
        label-width="200px"
        ref="forgetRef"
        :model="forget.data"
        :rules="forget.rules"
        label-position="right"
        style="width: 50%"
      >
        <el-row>
          <el-col>
            <el-form-item
              label="账号："
              prop="userIdentity"
            >
              <el-input
                placeholder="账号"
                v-model="forget.data.userIdentity"
                :disabled="mon_count"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row>
          <el-col>
            <el-form-item
              label="手机号码:"
              prop="phone"
            >
              <el-input
                v-model="forget.data.userInfoMobile"
                
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row> -->
      <el-row>
          <el-col>
            <el-form-item label="校验码:" prop="verification">
          <el-input
                type="verification"
                placeholder="校验码"
                v-model="forget.data.verification"
                style="width:160px;float:left;height:30px;line-height:20px"
              ></el-input>
              <div
                class="code1"
                @click="refreshCode"
              >
                <identify :identifyCode="identifyCode"></identify>
              </div>
              </el-form-item>
              </el-col>
        </el-row>
        <el-row>
          <el-form-item label="验证码:" prop="verificationCode">
            <el-col :span="18">
              <el-input v-model="forget.data.verificationCode"></el-input>
            </el-col>
            <el-col :span="6">
              <el-button
                type="primary"
                :disabled="regverification || mon_count"
                @click="auth_code"
                >{{ mon_count ? count_down + "s" : "获取验证码" }}</el-button
              >
            </el-col>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              label="新密码:"
              prop="passwd"
            >
              <el-input
                type="password"
                v-model="forget.data.password"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col>
            <el-form-item
              label="确认密码:"
              prop="checkPass"
            >
              <el-input
                type="password"
                v-model="forget.checkpassword"
                auto-complete="off"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :span="20">
          <el-col :span="20">
            <el-form-item>
              <el-button
                type="primary"
                @click="forget_submit"
              >保 存</el-button>
              <el-button @click="back">取 消</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
  </div>
</template>
<script>

import identify from "../../../store/identify";
import cryptoObj from "../../../jiami/index.js";

export default {
  components: {
    identify,
  },
  data() {
    var checkpass = (rule, value, callback) => {
      if (this.forget.checkpassword == "") {
        callback(new Error("请再次输入密码"));
      } else if (this.forget.checkpassword !== this.forget.data.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    var pass = (rule, value, callback) => {
      var tt = /^(?=^.{8,}$)(?=(?:.*?\d){1})(?=.*[a-z])(?=(?:.*?[A-Z]){1})(?=(?:.*?[@#$&.]){1})(?!.*\s)[0-9a-zA-Z@#$&\.]*$/; //不能全是数学和特殊字符.
      if (this.forget.data.password == "") {
        callback(new Error("请输入密码"));
      } else if (!tt.test(this.forget.data.password)) {
        callback(
          new Error(
            "密码必须是 大写字母，小写字母，特殊字符(包含 . @ # $ & )、数字 等其中任意四种类型或四种类型以上组合，且不能少于8位"
          )
        );
      } else {
        callback();
      }
    };
    // var phone = (rule, value, callback) => {
    //   var reg = 11 && /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/;
    //   if (this.forget.data.userInfoMobile == "") {
    //     callback(new Error("请输入手机号码"));
    //   } else if (!reg.test(this.forget.data.userInfoMobile)) {
    //     callback(new Error("手机格式不正确"));
    //   } else {
    //     callback();
    //   }
    // };
    var verification = (rule, value, callback) => {
      var reg = this.identifyCode;
      if (this.forget.data.verification == "") {
        callback(new Error("请输入校验码，字母小写"));
      } else if (reg !== this.forget.data.verification) {
        callback(new Error("校验码不正确"));
      } else {
        callback();
      }
    };
    return {
      title:"",
      identifyCodes: "1234567890abcdefghijklmnopqrstuvwxyz",
      identifyCode: "",
      url: {
       sms: "/draw/sms/send2",
       draw_forget_password: "/draw/userinfo/password"
      },
      forget: {
        checkpassword: "",
        data: {
          userIdentity: "",
          // userInfoMobile: "",
          password: "",
          verificationCode: "",
          verification:""
        },
        rules: {
          userIdentity: [
            {
              required: true,
              message: "请输入用户名",
              trigger: "blur"
            }
          ],
          checkPass: [
            {
              validator: checkpass,
              trigger: "blur"
            }
          ],
          passwd: [
            {
              validator: pass,
              trigger: "blur"
            }
          ],
          // phone: [
          //   {
          //     validator: phone,
          //     trigger: "blur"
          //   }
          // ],
          verification: [
            { validator: verification, trigger: "blur" }
          ]
        }
      },
      count_down: 0, //倒计时
      
    };
  },
  mounted() {
    this.identifyCode = "";
    this.makeCode(this.identifyCodes, 4);
    document
      .querySelector("body")
      .setAttribute("style", "background-image:url()");
  },
  computed: {
    regverification(){
      var reg = this.identifyCode;
      if (this.forget.data.verification == "") {
        return true;
      } else if (reg !== this.forget.data.verification) {
        return true;
      } else {
        return false;
      }
    },
    // regphone() {
    //   let reg = /^1[3,4,5,6,7,8,9][0-9]{9}$/;
    //   if (reg.test(this.register.data.contactPersonTel)) {
    //     return false;
    //   } else {
    //     return true;
    //   }
    // },
    mon_count() {
      if (this.count_down === 0) {
        return false;
      } else {
        setTimeout(() => {
          if (this.count_down > 0) {
            this.count_down = this.count_down - 1;
          }
        }, 1000);
        return true;
      }
    }
  },
  methods: {
    forget_submit() {
      this.$refs.forgetRef.validate(valid => {
        if (valid) {
          //post请求
          this.forget.data.password = cryptoObj.encryptFunc(
            this.forget.data.password,
            "1234567890123456"
          );
            debugger
          this.$http
            .post(this.url.draw_forget_password, this.forget.data)
            .then(res => {
              if (res.body.status == 200) {
                this.$message.success("修改密码成功，请重新登录");
                this.back();
              } else {
                this.$message.error(res.body.message);
              }
            });
        } else {
           this.$message({
            message: "请认真填写信息",
            type: "warning"
          });
          return false;
        }
      });
    },
    auth_code() {
    this.count_down = 60;
      let data = { mobile: this.forget.data.userIdentity };
      this.$http.post(this.url.sms, data, { emulateJSON: true }).then(
        res => {
          if (res.body.status == 200) {
            this.$message.success("发送成功");
          } else {
            this.count_down = 0;
            // this.$message.error("发送失败");
            this.$message.error(res.data.message);
          }
        },
        err => {
          this.count_down = 0;
          this.$message.error("发送失败");
        }
      );
    },
    back() {
      this.$refs.forgetRef.resetFields();
      this.forget.data.userIdentity = "";
      // this.forget.data.userInfoMobile = "";
      this.forget.data.password = "";
      this.forget.data.verificationCode = "";
      this.forget.data.verification = "";
      this.checkpassword = "";
      this.$router.go(-1);
    },
    refreshCode() {
      this.identifyCode = "";
      this.makeCode(this.identifyCodes, 4);
    },
    makeCode(o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ];
      }
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    clean(){
      this.$refs.forgetRef.resetFields();
      this.forget.data.organizationCode = "";
      this.forget.data.contactPersonTel = "";
      this.forget.data.password = "";
      this.forget.data.verificationCode = "";
      this.forget.data.verification = "";
      this.checkpassword = "";
    }
  }
};
</script>
<style>
@import "../../../styles/css/login.css";
</style>



// WEBPACK FOOTER //
// src/views/constructionUnit/user/drawforgetpassword.vue